@if (videoId) {
  <div class="holder">
    <div class="video-info-container">
      <div class="info-heading">
        Video Information
      </div>
      @if (!modifyingName) {
        <div class="info-entry">
          <span class="label">Name:</span>
          <span (click)="modifiedName = modifiedName || this.name || ''; modifyingName = true; $event.stopPropagation();" class="edit-value">{{ this.name }}</span>
        </div>
      }
      @if (modifyingName) {
        <div class="modifying-name">
          <span class="label">Name:</span>
          <input #nameInput (blur)="(!modifiedName || modifiedName === this.name) && (modifyingName = false);" type="text" pInputText [(ngModel)]="modifiedName">
          <p-button (onClick)="changeName()">Rename</p-button>
        </div>
      }
      <div class="info-entry">
        @if(duration && isFinite(duration)){
          <span class="label">Duration:</span>
          <span class="value">{{ formatDuration(duration)}}</span>
        }
      </div>
      <div class="info-entry">
        @if(size){
          <span class="label">Size:</span>
          <span class="value">{{size}}</span>
          }
      </div>
      <div class="info-entry">
        <span class="label">Format:</span> <span class="value">{{format}}</span>
      </div>
    </div>
    <div class="download-container">
      <div class="download-heading">Download Video</div>
      <div class="download">
        <button type="button" class="download-button p-button" (click)="downloadVideo()" data-testing-id="workbench-video-recording-download-btn">Download</button>
      </div>
    </div>
    @if (activeTestRun || activeActivity) {
      <div>
        <div class="tool-heading">
          Add Video Recording to Finding
        </div>
        <wm-add-to-finding type="videoSnippet" [addedToFinding]="addedToFinding" (findingSelected)="addToFinding($event)"></wm-add-to-finding>
      </div>
    }
  </div>
} @else {
  No Tools available.
}
